import React from "react";
import {Form} from "../../XLibItems";
import {XInputDecimal} from "@michalrakus/x-react-web-lib/XInputDecimal";
import {XInputText} from "@michalrakus/x-react-web-lib/XInputText";
import {XFormFooter} from "@michalrakus/x-react-web-lib/XFormFooter";
import {XInputDate} from "@michalrakus/x-react-web-lib/XInputDate";
import {XFormBaseModif} from "@michalrakus/x-react-web-lib/XFormBaseModif";
import {
    XFormAutoCompleteColumn,
    XFormColumn, XFormCustomColumn,
    XFormDataTable2
} from "@michalrakus/x-react-web-lib/XFormDataTable2";
import {XObject} from "@michalrakus/x-react-web-lib/XObject";
import {XFormHeader} from "@michalrakus/x-react-web-lib/XFormHeader";
import {XsGroupByFieldBrowse} from "./XsGroupByFieldBrowse";
import {XsGroupByFieldForm} from "./XsGroupByFieldForm";
import {XsStatFieldBrowse} from "./XsStatFieldBrowse";
import {XsStatFieldForm} from "./XsStatFieldForm";
import type {XFormProps} from "@michalrakus/x-react-web-lib/XFormBase";
import {XCustomFilter} from "@michalrakus/x-react-web-lib/FindParam";
import {XsTable} from "../../model/statistics/xs-table.entity";
import {Utils, XsAccessType} from "../../Utils";
import {stringAsDB} from "@michalrakus/x-react-web-lib/XUtilsConversions";
import {UtilsCommon} from "../../common/UtilsCommon";
import {ColumnBodyOptions} from "primereact/column";
import {XsTableSubtable} from "../../model/statistics/xs-table-subtable.entity";
import {Dialog} from "primereact/dialog";
import {XButtonIconNarrow} from "@michalrakus/x-react-web-lib/XButtonIconNarrow";
import {XDropdownEnum} from "../user/XDropdownEnum";
import {EnumEnum, XsRowAccessType} from "../../common/enums";
import {XMultiSelect} from "@michalrakus/x-react-web-lib/XMultiSelect";
import {OperationType} from "@michalrakus/x-react-web-lib/XUtils";
import {XUtilsCommon} from "@michalrakus/x-react-web-lib/XUtilsCommon";

@Form("XsTable")
export class XsTableForm extends XFormBaseModif {

    constructor(props: XFormProps) {
        super(props);

        this.state.showSqlQueryDialogState = {opened: false};

        this.onClickAddRowSubtable = this.onClickAddRowSubtable.bind(this);
        this.createFilterForXsGroupByField = this.createFilterForXsGroupByField.bind(this);
    }

    createNewObject(): XObject {
        return {rowAccessType: {id: 197, code: "onlyAdmin", name: "iba admin"}, sluzbaList: [], xsTableGroupByFieldForColumnsList: [], xsTableGroupByFieldForRowsList: [], xsTableSubtableList: [], version: 0};
    }

    preInitForm(xsTable: XsTable, operationType: OperationType.Insert | OperationType.Update) {
        // sortujeme tu lebo ak pouzijeme prop sortField na tabulke, tak sortuje v priebehu editacie
        xsTable.xsTableSubtableList = XUtilsCommon.arraySort(xsTable.xsTableSubtableList, "subtableOrder");
        xsTable.xsTableGroupByFieldForColumnsList = XUtilsCommon.arraySort(xsTable.xsTableGroupByFieldForColumnsList, "fieldOrder");
        xsTable.xsTableGroupByFieldForRowsList = XUtilsCommon.arraySort(xsTable.xsTableGroupByFieldForRowsList, "fieldOrder");
    }

    formReadOnly(object: XObject, field: string): boolean {
        return !Utils.xsUserHasAccess(XsAccessType.usageOnly);
    }

    onClickAddRowSubtable() {
        this.onTableAddRow("xsTableSubtableList", {createSumRow: false, createSumColumn: false});
    };

    createFilterForXsGroupByField(object: XsTable, rowData: any): XCustomFilter | undefined {
        let filter: XCustomFilter | undefined = undefined;
        if (object) {
            // create condition for every entity of subtable
            let whereExistsList: string[] = [];
            for (const xsTableSubtable of object.xsTableSubtableList) {
                whereExistsList.push(`EXISTS (SELECT 1 FROM ${Utils.getSchema()}.xs_group_by_field_by_entity gbe WHERE gbe.xs_group_by_field_id = [id] AND gbe.entity = ${stringAsDB(xsTableSubtable.xsStatField.entity)})`);
            }
            // exists condition is used for group by types with mandatory fields - for "date types" day/month/year is exists not used
            // (as field is usually used date field from XsStatField)
            filter = {
                where: `(([fieldType.code] NOT IN (:...dateTypeList) AND (${whereExistsList.join(" AND ")})) OR ([fieldType.code] IN (:...dateTypeList)))`,
                params: {dateTypeList: UtilsCommon.xGroupByTypeDateTypeList()}
            };
        }
        return filter;
    }

    showSqlQuery(tableRow: XsTableSubtable) {
        this.setState({showSqlQueryDialogState: {opened: true, sqlQuery: tableRow.sqlQuery}});
    }

    render() {
        return (
            <div>
                <XFormHeader form={this} label="Statistic table"/>
                <div className="x-form-row">
                    <div className="x-form-col">
                        <div className="x-form-row justify-content-between">
                            <XInputText form={this} field="label" label="Label" inputStyle={{width:'30rem'}}/>
                            <div className="x-form-inline-row">
                                <XInputDate form={this} field="modifDate" label="Dátum modif." labelStyle={{width:'9rem'}} readOnly={true}/>
                                <XInputText form={this} field="modifXUser.name" label="Modifikoval" labelStyle={{width:'9rem'}} inputStyle={{width:'12.35rem'}} readOnly={true}/>
                                <XInputDecimal form={this} field="id" label="ID" labelStyle={{width:'3rem'}} readOnly={true}/>
                            </div>
                        </div>
                        <XDropdownEnum form={this} assocField="rowAccessType" label="Access type" enumEnumCode={EnumEnum.xsRowAccessType}/>
                        <XMultiSelect form={this} assocToMany="sluzbaList" displayField="nazov" label="Služby" sortField="nazov" readOnly={(this.state.object as XsTable)?.rowAccessType?.code !== XsRowAccessType.specificUsers}/>
                        {/* table is sorted by valueFrom in method this.preInitForm, default sort by id is turned off (sortField="none") */}
                        <XFormDataTable2 form={this} assocField="xsTableSubtableList" label="Statistic fields" sortField="none"
                                         onClickAddRow={this.onClickAddRowSubtable}>
                            <XFormColumn field="subtableOrder" header="Order" width="4rem"/>
                            <XFormAutoCompleteColumn assocField="xsStatField" displayField="label" header="Statistic field" width="30rem"
                                                     searchBrowse={<XsStatFieldBrowse/>} assocForm={<XsStatFieldForm/>}
                                                     addRowEnabled={Utils.xsUserHasAccess(XsAccessType.full)}/>
                            <XFormColumn field="xsStatField.entity" header="Entity" width="15rem"/>
                            <XFormColumn field="label" header="Label in excel" width="25rem"/>
                            <XFormColumn field="createSumRow" header="Create sum row" width="10rem"/>
                            <XFormColumn field="createSumColumn" header="Create sum column" width="10rem"/>
                            <XFormColumn field="filter" header="Filter" width="15rem"/>
                            <XFormCustomColumn field="sqlQuery" header="Sql" width="2.2rem"
                                               body={(tableRow: any, options: ColumnBodyOptions) => <XButtonIconNarrow icon="pi pi-search" onClick={() => this.showSqlQuery(tableRow)} addMargin={false}/>}/>
                        </XFormDataTable2>
                        <div className="x-form-row justify-content-between">
                            <div className="x-form-inline-row">
                                <XInputDecimal form={this} field="statFieldLabelWidth" label="Statistic field label width" labelStyle={{width:'15rem'}} inputStyle={{width:'5rem'}}/>
                                <XInputDecimal form={this} field="valueColumnsWidth" label="Value columns width" labelStyle={{width:'13rem'}} inputStyle={{width:'5rem'}}/>
                            </div>
                        </div>
                        <XFormDataTable2 form={this} assocField="xsTableGroupByFieldForColumnsList" label="Group by fields for columns" sortField="none">
                            <XFormColumn field="fieldOrder" header="Order" width="4rem"/>
                            <XFormAutoCompleteColumn assocField="xsGroupByField" displayField="label" header="Group by field" width="25rem" fields={["fieldType.name"]}
                                                     searchBrowse={<XsGroupByFieldBrowse/>} assocForm={<XsGroupByFieldForm/>} filter={this.createFilterForXsGroupByField}
                                                     addRowEnabled={Utils.xsUserHasAccess(XsAccessType.full)}/>
                            <XFormColumn field="xsGroupByField.fieldType.name" header="Field type" width="15rem"/>
                            <XFormColumn field="filter" header="Filter" width="15rem"/>
                        </XFormDataTable2>
                        <XFormDataTable2 form={this} assocField="xsTableGroupByFieldForRowsList" label="Group by fields for rows" sortField="none">
                            <XFormColumn field="fieldOrder" header="Order" width="4rem"/>
                            <XFormAutoCompleteColumn assocField="xsGroupByField" displayField="label" header="Group by field" width="25rem" fields={["fieldType.name"]}
                                                     searchBrowse={<XsGroupByFieldBrowse/>} assocForm={<XsGroupByFieldForm/>} filter={this.createFilterForXsGroupByField}
                                                     addRowEnabled={Utils.xsUserHasAccess(XsAccessType.full)}/>
                            <XFormColumn field="xsGroupByField.fieldType.name" header="Field type" width="15rem"/>
                            <XFormColumn field="width" header="Width" width="5rem"/>
                            <XFormColumn field="filter" header="Filter" width="15rem"/>
                        </XFormDataTable2>
                    </div>
                </div>
                <XFormFooter form={this}/>
                <Dialog visible={this.state.showSqlQueryDialogState.opened} onHide={() => this.setState({showSqlQueryDialogState: {opened: false}})}>
                    <div>{this.state.showSqlQueryDialogState.sqlQuery}</div>
                </Dialog>
            </div>
        );
    }
}
